import botStore from "../state/store";

// Firebase UIDs — used to tell a store id in the path apart from a route word
// like "macros" or "v2".
const STORE_ID_PATTERN = /^[A-Za-z0-9]{20,}$/;

/**
 * Store id for outgoing API calls, resolved outside React.
 *
 * The backend keys its rate limiter and request logs on the `storeId` HEADER
 * (bik-shared-python reads it in `LoggingContext.set_from_api_call`); the store
 * id in the request body only reaches auth, not the rate limiter. Without this
 * every store shares one `no-store` rate-limit bucket.
 *
 * Redux is authoritative, but requests can fire before the flow is loaded and
 * `homeState` is populated, so fall back to the store id in the route
 * (`/:storeId/...` and `/macros/:storeId/...`).
 */
export const getCurrentStoreId = (): string => {
  const storeIdFromState = botStore.getState()?.homeState?.storeId;
  if (storeIdFromState) {
    return storeIdFromState;
  }

  const segments = window.location.pathname.split("/").filter(Boolean);
  const candidate = segments[0] === "macros" ? segments[1] : segments[0];
  return candidate && STORE_ID_PATTERN.test(candidate) ? candidate : "";
};
